import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}><path d="M80 280h256v48H80zm0-96h320v48H80zm0-96h352v48H80zM80 376h288v48H80z" /></svg>;